import { jwtDecode } from 'jwt-decode';

import { IUserProfileResponse } from 'api/components/User/types';

import { AUTH_TOKEN_NAME } from 'constants/api';
import { ALL_PROBLEM_ZONES, ProblemZone } from 'constants/user';

import { getCookie } from 'helpers/cookie';

type TokenPayload = {
    user_id?: string | number;
    time?: string;
    token_type?: string;
};

const userAPIResponseTransformer = <T extends { problem_zones: ProblemZone[]; user_id: number }>(
    userData: T | IUserProfileResponse
) => {
    return {
        ...userData,
        problem_zones:
            !userData?.problem_zones?.length || userData?.problem_zones?.includes(ALL_PROBLEM_ZONES as ProblemZone)
                ? Object.values(ProblemZone)
                : userData.problem_zones,
    };
};

const safeJWTDecode = (token?: string | null): TokenPayload | null => {
    try {
        return token ? jwtDecode<TokenPayload>(token) : null;
    } catch {
        return null;
    }
};

// New token type: CWT token, JWT-token with user_id as string-type, JWT-token with token_type as string-type
const isNewTokenType = (token: string | null, wellfunnelToken: string | null) => {
    const cookieToken = getCookie(AUTH_TOKEN_NAME);

    if (wellfunnelToken && wellfunnelToken !== 'null') return true;

    if (token) {
        const decoded = safeJWTDecode(token);

        return typeof decoded?.user_id === 'string';
    } else if (cookieToken) {
        const decoded = safeJWTDecode(cookieToken);

        return Boolean(decoded?.token_type);
    }

    return true;
};

const isJwtFormat = (token: string | null) => {
    return Boolean(safeJWTDecode(token));
};

export { isJwtFormat, isNewTokenType, userAPIResponseTransformer };
